import { FormMessage } from '@/components/ui/form';
import { cn } from '@/lib/utils';

export default function FieldErrorMessage({
  error,
  className,
}: {
  error: string | undefined;
  className?: string;
}) {
  if (error) {
    return (
      <div className={cn('mt-3 text-xs md:text-sm', className)}>
        <FormMessage>{error}</FormMessage>
      </div>
    );
  }
  return null;
}
